import { render } from "./SliderProduct.vue?vue&type=template&id=608332ca&scoped=true"
import script from "./SliderProduct.vue?vue&type=script&lang=js"
export * from "./SliderProduct.vue?vue&type=script&lang=js"

import "./SliderProduct.vue?vue&type=style&index=0&id=608332ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608332ca"]])

export default __exports__